"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackofficeRequisitionAttachmentsAttachmentDtoToJSON = exports.BackofficeRequisitionAttachmentsAttachmentDtoFromJSONTyped = exports.BackofficeRequisitionAttachmentsAttachmentDtoFromJSON = exports.instanceOfBackofficeRequisitionAttachmentsAttachmentDto = void 0;
var runtime_1 = require("../runtime");
var BackofficeRequisitionAttachmentsAttachmentDtoReportData_1 = require("./BackofficeRequisitionAttachmentsAttachmentDtoReportData");
var BackofficeRequisitionAttachmentsAttachmentDtoReportRelease_1 = require("./BackofficeRequisitionAttachmentsAttachmentDtoReportRelease");
var BackofficeRequisitionAttachmentsAttachmentDtoSignee_1 = require("./BackofficeRequisitionAttachmentsAttachmentDtoSignee");
var BackofficeRequisitionAttachmentsAttachmentDtoUploader_1 = require("./BackofficeRequisitionAttachmentsAttachmentDtoUploader");
/**
 * Check if a given object implements the BackofficeRequisitionAttachmentsAttachmentDto interface.
 */
function instanceOfBackofficeRequisitionAttachmentsAttachmentDto(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "isSharedWithPhysician" in value;
    isInstance = isInstance && "isSharedWithPatient" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "backofficeReqScanDownloadUrl" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "dateModified" in value;
    isInstance = isInstance && "encrypted" in value;
    isInstance = isInstance && "originalFilename" in value;
    isInstance = isInstance && "originalFilesize" in value;
    isInstance = isInstance && "removed" in value;
    isInstance = isInstance && "requisitionId" in value;
    isInstance = isInstance && "reportResult" in value;
    isInstance = isInstance && "signee" in value;
    isInstance = isInstance && "uploader" in value;
    isInstance = isInstance && "uuid" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "verified" in value;
    return isInstance;
}
exports.instanceOfBackofficeRequisitionAttachmentsAttachmentDto = instanceOfBackofficeRequisitionAttachmentsAttachmentDto;
function BackofficeRequisitionAttachmentsAttachmentDtoFromJSON(json) {
    return BackofficeRequisitionAttachmentsAttachmentDtoFromJSONTyped(json, false);
}
exports.BackofficeRequisitionAttachmentsAttachmentDtoFromJSON = BackofficeRequisitionAttachmentsAttachmentDtoFromJSON;
function BackofficeRequisitionAttachmentsAttachmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'category': json['category'],
        'contentType': json['content_type'],
        'isSharedWithPhysician': json['is_shared_with_physician'],
        'isSharedWithPatient': json['is_shared_with_patient'],
        'name': json['name'],
        'backofficeReqScanDownloadUrl': json['backoffice_req_scan_download_url'],
        'dateCreated': json['date_created'],
        'dateModified': json['date_modified'],
        'encrypted': json['encrypted'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
        'inStagingArea': !(0, runtime_1.exists)(json, 'in_staging_area') ? undefined : json['in_staging_area'],
        'note': !(0, runtime_1.exists)(json, 'note') ? undefined : json['note'],
        'originalFilename': json['original_filename'],
        'originalFilesize': json['original_filesize'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positive_finding') ? undefined : json['positive_finding'],
        'reportRelease': !(0, runtime_1.exists)(json, 'report_release') ? undefined : (0, BackofficeRequisitionAttachmentsAttachmentDtoReportRelease_1.BackofficeRequisitionAttachmentsAttachmentDtoReportReleaseFromJSON)(json['report_release']),
        'removed': json['removed'],
        'requisitionId': json['requisition_id'],
        'reportData': !(0, runtime_1.exists)(json, 'report_data') ? undefined : (0, BackofficeRequisitionAttachmentsAttachmentDtoReportData_1.BackofficeRequisitionAttachmentsAttachmentDtoReportDataFromJSON)(json['report_data']),
        'reportResult': json['report_result'],
        'signee': (0, BackofficeRequisitionAttachmentsAttachmentDtoSignee_1.BackofficeRequisitionAttachmentsAttachmentDtoSigneeFromJSON)(json['signee']),
        'uploader': (0, BackofficeRequisitionAttachmentsAttachmentDtoUploader_1.BackofficeRequisitionAttachmentsAttachmentDtoUploaderFromJSON)(json['uploader']),
        'uuid': json['uuid'],
        'url': json['url'],
        'verified': json['verified'],
    };
}
exports.BackofficeRequisitionAttachmentsAttachmentDtoFromJSONTyped = BackofficeRequisitionAttachmentsAttachmentDtoFromJSONTyped;
function BackofficeRequisitionAttachmentsAttachmentDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'category': value.category,
        'content_type': value.contentType,
        'is_shared_with_physician': value.isSharedWithPhysician,
        'is_shared_with_patient': value.isSharedWithPatient,
        'name': value.name,
        'backoffice_req_scan_download_url': value.backofficeReqScanDownloadUrl,
        'date_created': value.dateCreated,
        'date_modified': value.dateModified,
        'encrypted': value.encrypted,
        'image': value.image,
        'in_staging_area': value.inStagingArea,
        'note': value.note,
        'original_filename': value.originalFilename,
        'original_filesize': value.originalFilesize,
        'positive_finding': value.positiveFinding,
        'report_release': (0, BackofficeRequisitionAttachmentsAttachmentDtoReportRelease_1.BackofficeRequisitionAttachmentsAttachmentDtoReportReleaseToJSON)(value.reportRelease),
        'removed': value.removed,
        'requisition_id': value.requisitionId,
        'report_data': (0, BackofficeRequisitionAttachmentsAttachmentDtoReportData_1.BackofficeRequisitionAttachmentsAttachmentDtoReportDataToJSON)(value.reportData),
        'report_result': value.reportResult,
        'signee': (0, BackofficeRequisitionAttachmentsAttachmentDtoSignee_1.BackofficeRequisitionAttachmentsAttachmentDtoSigneeToJSON)(value.signee),
        'uploader': (0, BackofficeRequisitionAttachmentsAttachmentDtoUploader_1.BackofficeRequisitionAttachmentsAttachmentDtoUploaderToJSON)(value.uploader),
        'uuid': value.uuid,
        'url': value.url,
        'verified': value.verified,
    };
}
exports.BackofficeRequisitionAttachmentsAttachmentDtoToJSON = BackofficeRequisitionAttachmentsAttachmentDtoToJSON;
